// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__MhbAc","title":"CardHeader_title__AFdbx"};